module.exports = __webpack_public_path__ + "img/EATechWord2.3695576f.png";